import { getFunctions, httpsCallable } from "firebase/functions";
import { app } from "../firebase";

const functions = getFunctions(app, "us-central1"); // 👈 explicitly set region
const moderateMessage = httpsCallable(functions, "moderateMessage");

const BLOCKED_CATEGORIES = [
  "sexual",
  "sexual/minors",
  "harassment",
  "harassment/threatening",
  "hate",
  "hate/threatening",
  "illicit",
  "illicit/violent",
  "self-harm",
  "self-harm/intent",
  "self-harm/instructions",
  "violence",
  "violence/graphic",
];

const BLOCK_THRESHOLD = 0.8;
const REVIEW_KEYWORDS = [
  /\bshit\b/i,
  /\bfuck(?:ing|ed|er|s)?\b/i,
  /\bcunt\b/i,
  /\bbitch(?:es)?\b/i,
  /\basshole\b/i,
  /\bdickhead\b/i,
  /\bprick\b/i,
  /\bwanker\b/i,
  /\bidiot\b/i,
  /\bkill\s+yourself\b/i,
];

const needsLocalReview = (message = "") =>
  REVIEW_KEYWORDS.some((pattern) => pattern.test(message));

const shouldBlockMessage = ({
  flagged,
  categories = {},
  categoryScores = {},
}, message = "") => {
  if (needsLocalReview(message)) return true;

  if (!flagged) return false;

  const hasScores = Object.keys(categoryScores).length > 0;
  if (hasScores) {
    return BLOCKED_CATEGORIES.some(
      (category) => (categoryScores[category] || 0) >= BLOCK_THRESHOLD
    );
  }

  return BLOCKED_CATEGORIES.some((category) => categories[category] === true);
};

export const isSafe = async (message) => {
  try {
    const res = await moderateMessage({ message });
    return !shouldBlockMessage(res.data, message);
  } catch (err) {
    console.error("Moderation error:", err);
    throw err;
  }
};

export const moderateText = async (message) => {
  try {
    const res = await moderateMessage({ message });
    const blocked = shouldBlockMessage(res.data, message);
    return {
      ok: true,
      safe: !blocked,
      flagged: Boolean(res.data.flagged),
      categories: res.data.categories || {},
      categoryScores: res.data.categoryScores || {},
    };
  } catch (err) {
    console.error("Moderation error:", err);
    return {
      ok: false,
      safe: false,
      error: err,
    };
  }
};
//Image Moderation
const moderateImage = httpsCallable(functions, "moderateImage");

export const isImageSafe = async (imageUrl) => {
  try {
    const res = await moderateImage({ imageUrl });
    return moderateImageResult(res.data).safe;
  } catch (err) {
    console.error("Image moderation error:", err);
    return true;
  }
};

const isLikelyUnsafe = (value) => value === "LIKELY" || value === "VERY_LIKELY";

const moderateImageResult = ({ adult, violence, racy } = {}) => ({
  safe:
    !isLikelyUnsafe(adult) &&
    !isLikelyUnsafe(violence) &&
    !isLikelyUnsafe(racy),
  ratings: { adult, violence, racy },
});

export const moderateImageUpload = async (imageUrl) => {
  try {
    const res = await moderateImage({ imageUrl });
    const result = moderateImageResult(res.data);

    return {
      ok: true,
      ...result,
    };
  } catch (err) {
    console.error("Image moderation error:", err);

    return {
      ok: false,
      safe: true,
      error: err,
    };
  }
};
